import React from 'react'
import {BrowserRouter, Switch, Route} from "react-router-dom";
import Home from "./Home";
import GlobalStyle from "../GlobalStyle";
import Staking from "./Staking";
import Loans from "./Loans";
import Navbar from "../components/Navbar";
import ScrollToTop from "../components/ScrollToTop";
import Footer from "../components/Footer";


function Root() {


    return (
        <>
            <BrowserRouter>
                <GlobalStyle/>
                <ScrollToTop/>
                <Navbar/>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/Staking" component={Staking}/>
                    <Route exact path="/Loans" component={Loans}/>
                    <Route component={Home}/>
                </Switch>
            </BrowserRouter>
            <Footer />
        </>
    );
}

export default Root;
